{
	"selectAll": "Selecionar todos"
}
